import subha from "../../../assets/Subha.png";
import Varun from "../../../assets/VARUN.png"

export const AdminFinanceProfile = [
  { id: 1, title: "Varun", imgUrl: Varun },
];
